import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ConcurrentReportComponent } from 'src/app/modules/concurrent-report/page/concurrent-report/concurrent-report.component';

@Component({
  selector: 'app-modal-print-insured-report',
  templateUrl: './modal-print-insured-report.component.html',
  styleUrls: ['./modal-print-insured-report.component.scss']
})
export class ModalPrintInsuredReportComponent implements OnInit {

  @Input('isVisible') isVisible: boolean;
  @Input('titleText') titleText: string;
  @Output() closeModal = new EventEmitter();

  constructor(private router: Router, private comp: ConcurrentReportComponent) { }

  ngOnInit() {
  }

  close(comfirm: boolean): void {
    this.closeModal.emit(comfirm);
    if (comfirm == false) {
      this.comp.refreshPage();
      this.router.navigate(["/home/concurrent-report"])
    }
  }

}
